/* eslint-disable no-case-declarations */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {isNaN} from 'lodash';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Put, Get} from '@/api/request';
import RevertIcon from '@/assets/icons/Revert.svg';
import Button from '@/components/button/Button';
import {ADVANCE_SETUP_RESTRICTION} from '@/constants/advSetupConstant';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';

import BottomMenu from '../../menu/bottommenu/BottomMenu';

import {MEMBRANE_CUT_OFF_LABEL, MEMBRANE_CUT_OFF} from './pressureSettingConstant';

import './PressureSetting.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  topButtonProperties: store.setupStore.topButtonProperties,
}))
class PressureSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDefaultValue: false,
      isButtonBackPopUp: false,
      isPressureValueNotChange: true,
      ReturnValvePressure: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
      },
      newReturnValvePressure: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
      },
      defaultReturnValvePressure: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '20',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '15',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '10',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '7',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '3',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '0',
      },
    };
    this.onClick = this.onClick.bind(this);
    this.onClickReset = this.onClickReset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.successGetDefaultPressureSettings = this.successGetDefaultPressureSettings.bind(this);
    this.successGetPressureSettings = this.successGetPressureSettings.bind(this);
    this.sucessPostPressureConfig = this.sucessPostPressureConfig.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.PRESSURE_SETTING));
    this.setTopMenuProperties(true);
    this.getInitialValue();
  }

  componentWillUnmount() {}

  // eslint-disable-next-line react/sort-comp
  setTopMenuProperties = (disableMainButton) => {
    const topButtonProperties = {
      id: APPDATA.SAVE,
      label: APPDATA.SAVE,
      onClick: this.onClickTopMenu,
      disabled: disableMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    const titleMenuProperties = APPDATA.SYSTEM_SETTING;
    this.setupTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  setupTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  getInitialValue = () => {
    const param = {};
    const passingValue = {};
    Get(APPDATA.API.GET_FACTORY_DEFAULT_RETURN_VALVE, param, this.successGetDefaultPressureSettings, passingValue);
    Get(APPDATA.API.GET_RETURN_VALVE_PRESSURE_SETTINGS, param, this.successGetPressureSettings, passingValue);
  };

  // eslint-disable-next-line class-methods-use-this
  successGetDefaultPressureSettings = (response) => {
    // consoleLog("Response Get Default Pressure Settings", response);
    const tempReturnValvePressure = {
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };
    response.data.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        default:
          break;
      }
    });
    this.setState({
      defaultReturnValvePressure: {...tempReturnValvePressure},
    });
  };

  // eslint-disable-next-line class-methods-use-this
  successGetPressureSettings = (response) => {
    // consoleLog("Response Get Pressure Settings", response);
    this.props.dispatch(setupActions.updateDefaultReturnValvePressureParams(response.data));
    const tempReturnValvePressure = {
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '20',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '15',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '10',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };
    response.data.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
          tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure];
          break;
        default:
          break;
      }
    });
    this.setState(
      {
        ReturnValvePressure: {...tempReturnValvePressure},
        newReturnValvePressure: {...tempReturnValvePressure},
      },
      () => this.checkValueChange(),
    );
  };

  backAction = () => {
    if (this.state.isButtonBackPopUp === false) {
      this.goToHomeScreen();
      // let popUpButton = [
      // 	{
      // 		id: APPDATA.YES,
      // 		isPrimaryButton: true,
      // 		onClick: this.onClickPopUpBackButton,
      // 		label: APPDATA.YES,
      // 	},
      // 	{
      // 		id: APPDATA.NO,
      // 		isPrimaryButton: false,
      // 		onClick: this.onClickPopUpBackButton,
      // 		label: APPDATA.NO,
      // 	},
      // ];
      // this.props.dispatch(
      // 	modalActions.showPopUp({
      // 		popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.EXIT_PAGE.TITLE,
      // 		popUpText: (
      // 			<div>
      // 				{APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.EXIT_PAGE.TEXT}
      // 				<br />
      // 				{APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.EXIT_PAGE.QUESTION}
      // 			</div>
      // 		),
      // 		popUpQuestion: undefined,
      // 		popUpButton: popUpButton,
      // 	})
      // );
    } else {
      const popUpButton = [
        {
          id: APPDATA.SAVE,
          label: APPDATA.SAVE,
          isPrimaryButton: true,
          onClick: this.onClickModalButton,
          disabled: false,
        },
        {
          id: APPDATA.DISCARD,
          label: APPDATA.DISCARD,
          isPrimaryButton: false,
          onClick: this.onClickModalButton,
        },
      ];
      this.props.dispatch(
        modalActions.showPopUp({
          popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.TITLE,
          popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.TEXT,
          popUpButton,
        }),
      );
    }
  };

  //   onClickPopUpBackButton = (e) => {
  //     this.props.dispatch(modalActions.hidePopUp());
  //     switch (e.currentTarget.id) {
  //       case APPDATA.YES:
  //         this.goToHomeScreen();
  //         break;
  //       case APPDATA.NO:
  //         break;
  //     default: break;
  //     }
  //   };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.SAVE: {
        const popUpButton = [
          {
            id: APPDATA.SAVE,
            label: APPDATA.SAVE,
            isPrimaryButton: true,
            onClick: this.onClickModalButton,
            disabled: false,
          },
          {
            id: APPDATA.DISCARD,
            label: APPDATA.DISCARD,
            isPrimaryButton: false,
            onClick: this.onClickModalButton,
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.TITLE,
            popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.TEXT,
            popUpButton,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  //   onClickUnSaveSetting = (e) => {
  //     switch (e.currentTarget.id) {
  //       case APPDATA.YES:
  //         // SAVE
  //         this.saveConfig({SavePressureSetting: true});
  //         break;
  //       case APPDATA.NO:
  //         break;
  //       default:
  //         break;
  //     }
  //     this.props.dispatch(modalActions.hidePopUp());
  //     this.goToHomeScreen();
  //   };

  // eslint-disable-next-line class-methods-use-this
  goToHomeScreen = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  saveConfig = (nextProps) => {
    const {isPressureValueNotChange} = this.state;
    if (nextProps.SavePressureSetting) {
      if (!isPressureValueNotChange) this.postPressureConfig();
      this.setTopMenuProperties(true);
      this.setState({
        isButtonBackPopUp: false,
      });
    }
  };

  postPressureConfig = () => {
    const {newReturnValvePressure} = this.state;
    const param = [
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_5_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_10_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_30_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_50_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_100_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_300_KDA.toString(),
        [APPDATA.KEY.ReturnValvePressure]: '',
      },
    ];
    let i = 0;
    param.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
          param[i][APPDATA.KEY.ReturnValvePressure] = newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA];
          break;
        default:
          break;
      }
      i++;
    });
    const passingValue = {};
    Put(APPDATA.API.PUT_RETURN_VALVE_PRESSURE_SETTINGS, param, this.sucessPostPressureConfig, passingValue);
  };

  sucessPostPressureConfig = (response) => {
    const {newReturnValvePressure} = this.state;
    // consoleLog("response", response);
    if (response.data.message.includes('Failed')) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: response.data.message,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        }),
      );
    } else {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.SUCCESS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      const tempReturnValvePressure = {...newReturnValvePressure};
      this.setState(
        {
          ReturnValvePressure: tempReturnValvePressure,
        },
        () => {
          this.getInitialValue();
          this.checkValueChange();
        },
      );
    }
  };

  checkValueChange() {
    const {newReturnValvePressure, ReturnValvePressure, defaultReturnValvePressure} = this.state;
    // consoleLog("newReturnValvePressure", newReturnValvePressure);
    // consoleLog("ReturnValvePressure", ReturnValvePressure);
    // consoleLog("defaultReturnValvePressure", defaultReturnValvePressure);
    if (JSON.stringify(newReturnValvePressure) === JSON.stringify(defaultReturnValvePressure)) {
      this.setState({
        isDefaultValue: true,
      });
    } else {
      this.setState({
        isDefaultValue: false,
      });
    }
    // consoleLog(isDefaultValue)
    if (JSON.stringify(ReturnValvePressure) === JSON.stringify(newReturnValvePressure)) {
      this.setState({
        isButtonBackPopUp: false,
        isPressureValueNotChange: true,
      });
      this.setTopMenuProperties(true);
    } else {
      this.setState({
        isButtonBackPopUp: true,
        isPressureValueNotChange: false,
      });
      this.setTopMenuProperties(false);
    }
  }

  onChange(e) {
    const {newReturnValvePressure} = this.state;

    const tempReturnValvePressure = newReturnValvePressure;

    switch (e.type) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = e.value;
        break;
      default:
        break;
    }
    this.setState(
      {
        newReturnValvePressure: {...tempReturnValvePressure},
      },
      () => this.checkValueChange(),
    );
  }

  onClick(e) {
    const props = {
      // maxDigitAfterDecimal: APPDATA.CONFIGURATION.PRESSURE_SETTINGS.DECIMAL_PLACE_ACCURACY,
      // incrementValue: APPDATA.CONFIGURATION.PRESSURE_SETTINGS.INC_VALUE,
      // currentValue: 0,
      // headerTitle: APPDATA.PRESSURE_SETTING,
      // minValue: APPDATA.CONFIGURATION.PRESSURE_SETTINGS.MIN_VALUE,
      // maxValue: APPDATA.CONFIGURATION.PRESSURE_SETTINGS.MAX_VALUE,
      maxDigitAfterDecimal: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].DECIMAL_PLACE_ACCURACY,
      incrementValue: APPDATA.CONFIGURATION.PRESSURE_SETTINGS.INC_VALUE,
      currentValue: 0,
      headerTitle: APPDATA.PRESSURE_SETTING,
      minValue: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MIN_VALUE,
      maxValue: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].MAX_VALUE,
      info: ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.BOTTLE_PRESSURE].INFO,
      callback: this.onChange,
      unit: APPDATA.UNIT.psi,
      validatorInput: undefined,
    };
    switch (e.currentTarget.id) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        props.minValue = 0;
        // props.maxValue = 100
        break;
      default:
        break;
    }
    this.showNumpad(props);
  }

  onClickReset(e) {
    const {newReturnValvePressure, defaultReturnValvePressure} = this.state;

    const tempReturnValvePressure = newReturnValvePressure;
    switch (e.currentTarget.id) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] =
          defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] =
          defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] =
          defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] =
          defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] =
          defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA];
        break;
      default:
        break;
    }
    this.setState(
      {
        newReturnValvePressure: {...tempReturnValvePressure},
      },
      () => {
        this.checkValueChange();
        // this.postPressureConfig();
      },
    );
  }

  onClickResetDefault = () => {
    consoleLog('Restore button clicked');

    const popUpButton = [
      {
        id: APPDATA.APPLY,
        label: APPDATA.RESTORE.toUpperCase(),
        isPrimaryButton: true,
        onClick: this.onClickModalButton,
        disabled: false,
      },
      {
        id: APPDATA.CANCEL,
        label: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickModalButton,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.RESET_DEFAULT.TITLE,
        popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.RESET_DEFAULT.TEXT,
        popUpButton,
      }),
    );
    // let param = {}
    // let passingValue = {}
    // Get( APPDATA.API.GET_FACTORY_DEFAULT_RETURN_VALVE, param, this.successGetFactoryPressureSettings, passingValue)
  };

  onClickModalButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.APPLY:
        const {defaultReturnValvePressure} = this.state;

        this.setState(
          {
            ReturnValvePressure: {...defaultReturnValvePressure},
            newReturnValvePressure: {...defaultReturnValvePressure},
          },
          () => {
            this.checkValueChange();
            this.postPressureConfig();
          },
        );
        break;

      case APPDATA.CANCEL:
        break;
      case APPDATA.SAVE:
        this.saveConfig({SavePressureSetting: true});
        break;
      case APPDATA.DISCARD:
        // this.props.dispatch(
        // 	setupActions.showAlert({
        // 		alertShow: true,
        // 		alertText: APPDATA.MESSAGES.SYSTEM_SETTING.PRESSURE_SETTING.SAVE.DISCARD,
        // 		alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        // 	})
        // );
        this.goToHomeScreen();
        break;
      default:
        break;
    }
    this.props.dispatch(modalActions.hidePopUp());
  };

  // successGetFactoryPressureSettings = ( response) => {
  //     // consoleLog("Response Get Pressure Settings", response);
  //     let tempReturnValvePressure = {
  //         [MEMBRANE_CUT_OFF.CHIP_5_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_10_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_30_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_50_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_100_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_300_KDA]: "",
  //     }
  //     response.data.forEach((value) => {
  //         switch (value[APPDATA.KEY.MembraneCutOffSize]) {
  //             case MEMBRANE_CUT_OFF.CHIP_5_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_10_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_30_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_50_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_100_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_300_KDA.toString():
  //                 tempReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.ReturnValvePressure]
  //                 break;
  //             default:
  //                 break;
  //         }
  //     });
  //     this.setState({
  //         ReturnValvePressure: Object.assign({}, tempReturnValvePressure),
  //         newReturnValvePressure: Object.assign({}, tempReturnValvePressure)
  //     }, () => {
  //         this.checkValueChange()
  //         this.postPressureConfig()
  //     })
  // }
  showNumpad = (props) => {
    this.props.dispatch(
      modalActions.showModal({
        modalHeader: props.headerTitle,
        value: props.currentValue,
        callback: props.callback,
        maxValue: props.maxValue,
        minValue: props.minValue,
        maxDigitAfterDecimal: props.maxDigitAfterDecimal,
        incrementValue: props.incrementValue,
        unit: props.unit,
        validatorInput: props.validatorInput,
      }),
    );
  };

  render() {
    const {isDefaultValue, newReturnValvePressure, defaultReturnValvePressure} = this.state;
    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    return (
      <div style={style.constraint}>
        <div className="row rowHeight middleAlign">
          <div className="col-md-6 divColoredTitle">Return Valve Pressure Default Value</div>
          <div className="col-md-6">
            <button
              type="button"
              className="restoreDefaultButton"
              disabled={isDefaultValue}
              onClick={() => this.onClickResetDefault()}
            >
              {APPDATA.FIELD_NAME.RESTORE_ALL_DEFAULT.toUpperCase()}
            </button>
          </div>
        </div>
        <div className="pressureSettingContent middleAlign">
          <div className="col-md-6">
            <div className="row middleAlign">
              <div className="col-md-5 divTitle">{APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}</div>
              <div className="col-md-6 divTitle">{APPDATA.FIELD_NAME.PRESSURE}</div>
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_5_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_10_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_30_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="row middleAlign">
              <div className="col-md-5 divTitle">{APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}</div>
              <div className="col-md-6 divTitle">{APPDATA.FIELD_NAME.PRESSURE}</div>
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_50_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />

              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_100_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="pressureSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                value={newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                unit={APPDATA.UNIT.psi}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                onClick={this.onClickReset}
                className={
                  newReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA] ===
                  defaultReturnValvePressure[MEMBRANE_CUT_OFF.CHIP_300_KDA]
                    ? 'pressureResetButton not-visibile-div '
                    : 'pressureResetButton '
                }
                icon={RevertIcon}
              />
            </div>
          </div>
        </div>

        <BottomMenu />
      </div>
    );
  }
}
function Input(props) {
  const {label, value, unit, onClick, hideField, fullWidthInput, disabled} = props;
  const valueParse = parseFloat(value);
  const inputValue = isNaN(valueParse) ? value : valueParse; // .toFixed(decimal)
  const classInputCollumn = unit === undefined ? 'div-2col50 divInput center' : 'div-3colInputSettings divInput center';
  const classInputField = fullWidthInput ? 'inputField inputFullWitdh' : 'inputField';
  return (
    <div className={classInputCollumn}>
      {!hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {' '}
          {label}{' '}
        </span>
      )}
      {!hideField && (
        <input
          className={classInputField}
          id={label}
          value={value === APPDATA.EMPTY_FIELD ? '' : inputValue}
          readOnly
          onClick={onClick}
          disabled={disabled}
        />
      )}
      {unit !== undefined && !hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {' '}
          {unit}{' '}
        </span>
      )}
    </div>
  );
}

export default PressureSetting;
